import HighlightOffIcon from "@mui/icons-material/HighlightOff"
import {
    Box,
    Typography
} from "@mui/material"
import Modal from "@mui/material/Modal"
import React from "react"
import { getBaseStorageUrl } from "../../utils/Helpers"

export const PreviewModal = ({ showModal, setShowModal, invoiceData }) => {
    let url = invoiceData?.url
    if (!(url?.startsWith("http://") || url?.startsWith("https://"))) {
        url = `${getBaseStorageUrl()}/${url}`
    }

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "100%",
        height: "100%",
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "10px",
    }

    return (
        <Modal open={showModal} onClose={() => setShowModal(false)}>
            <Box sx={style}>
                <div className="row-between" style={{ padding: "20px" }}>
                    <Typography id="modal-modal-title" variant="h8" component="h2">
                        {`Preview`}
                    </Typography>

                    <HighlightOffIcon
                        sx={{ cursor: "pointer" }}
                        size={30}
                        onClick={() => setShowModal(false)}
                    />
                </div>
                <embed
                    src={url}
                    type="application/pdf"
                    className="modal-pdf" // Use the CSS class for PDFs
                />
            </Box>
        </Modal>
    )
}
